import React from "react";

function Counter({ label, value, testId, accent }) {
  return (
    <div className="flex-1 rounded-md border border-border bg-surface px-3 py-2" data-testid={testId}>
      <p className="text-[10px] uppercase tracking-wide text-text-muted">{label}</p>
      <p className={`font-heading text-xl font-bold ${accent ? "text-primary" : "text-text-main"}`}>{value}</p>
    </div>
  );
}

export function CountersBar({ total, assigned, left, current }) {
  return (
    <div className="mb-3 flex gap-2" data-testid="route-builder-counters">
      <Counter label="Total Addresses" value={total} testId="counter-total" />
      <Counter label="Assigned Across Routes" value={assigned} testId="counter-assigned" />
      <Counter label="Addresses Left" value={left} testId="counter-left" />
      <Counter label="Current Route Selected" value={current} testId="counter-current" accent />
    </div>
  );
}
